import React, { SetStateAction, useEffect, useState } from 'react';
import CloseIcon from '../../svgIcons/CloseIcon';
import HistoryIcon from '../../svgIcons/HistoryIcon';
import LogsAccordion from './LogsAccordion.tsx/LogsAccordion';
import NoRecordsFound from '../../../images/noPropertyImg.svg';
import styles from './AddProperty.module.css';
import { AppDispatch } from '../../../redux/rootReducer';
import { useDispatch } from 'react-redux';
import { getLockerTypes } from '../../../redux/locker-version/action/locker-version.actions';

export interface PropertyProps {
    zip: string | null;
    city: string | null;
    name: string;
    state: string;
    images: string[];
    mapUrl: string;
    appLink: string;
    street1: string;
    openTime: string;
    timeZone: string;
    closeTime: string;
    listOfPOI: string;
    unitMapId: string;
    mappedInId: string;
    masterCode: string;
    confirmText: string;
    contactLink: string;
    description: string;
    mapFilePath: string;
    lockersCount: number;
    streetNumber: string;
    isPriceListed: boolean;
    isCardRequired: boolean;
    propertyStatus: string | null;
    reportSendTime: string | null;
    unitMapAssetId: string | null;
    isOpenViaChecked: false;
    endingTourMessage: string | null;
    managementCompany: string;
    isDocumentRequired: true;
    leasingAgentNumber: string | null;
    showCardDisclaimer: false;
    leasingAgentEmailId: string | null;
    beginningTourMessage: string | null;
    customCardDisclaimer: string | null;
    propertyDetailsForBot: null | string;
    openViaChatBotPropertyId: null | string;
    radius: number | null;
    googlePlacesId: string;
    amazonKeyAccessId: string | null;
    mappedInFloorId: string | null;
    lockerName: string | null;
    errorNotification?: boolean | undefined;
}

export interface PropertyModalProps {
    new_values: PropertyProps;
    old_values: PropertyProps;
    updatedAt: string;
    record_id: string;
    adminName: string;
    adminEmail: string;
}

interface PropertyInformationModalProps {
    data: PropertyModalProps[];
    setShowPropertyInformationLogs: React.Dispatch<SetStateAction<boolean>>;
}

const PropertyInformationModalBody = ({ data, setShowPropertyInformationLogs }: PropertyInformationModalProps) => {
    const dispatch: AppDispatch = useDispatch();

    useEffect(() => {
        dispatch(getLockerTypes());
    }, []);

    const [activeIndex, setActiveIndex] = useState<number | null>(0);
    const [noRecordsFound, setNoRecordsFound] = useState(false);
    type AnyObject = { [key: string]: any };

    const checkRecordsExist = () => {
        let isEqual = true;
        if (data.length && isEqual) {
            for (const record of data) {
                isEqual = isEqualByKeysAndValues(record.old_values, record.new_values);

                if (!isEqual) {
                    setNoRecordsFound(false);
                    return;
                }
            }
            setNoRecordsFound(isEqual);
        }
    };

    useEffect(() => {
        checkRecordsExist();
    }, []);

    // const isEqualByKeysAndValues = (obj1: AnyObject, obj2: AnyObject): boolean => {
    //     if (obj1 === obj2) return true;

    //     const keys1 = Object.keys(obj1);
    //     const keys2 = Object.keys(obj2);

    //     if (keys1.length !== keys2.length) {
    //         return false;
    //     }

    //     for (const key of keys1) {
    //         if (!keys2.includes(key)) {
    //             return false;
    //         }

    //         if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
    //             if (obj1[key].length !== obj2[key].length) {
    //                 return false;
    //             }

    //             const sortedArr1 = [...obj1[key]].sort();
    //             const sortedArr2 = [...obj2[key]].sort();

    //             for (let i = 0; i < sortedArr1.length; i++) {
    //                 if (sortedArr1[i] !== sortedArr2[i]) {
    //                     return false;
    //                 }
    //             }
    //         } else if (key === "leasingAgentNumber") {
    //             const val1 = obj1[key] ? obj1[key].toString() : obj1[key];
    //             const val2 = obj2[key] ? obj2[key].toString() : obj2[key];
    //             if (val1 !== val2) {
    //                 return false;
    //             }
    //         } else if (key === "latitude" || key === "longitude") {
    //             const val1 = obj1[key] ? obj1[key].toString() : obj1[key];
    //             const val2 = obj2[key] ? obj2[key].toString() : obj2[key];
    //             if (val1 !== val2) {
    //                 return false;
    //             } else {
    //                 return true;
    //             }
    //         } else {
    //             const val1 = obj1[key] === null ? "" : obj1[key];
    //             const val2 = obj2[key] === null ? "" : obj2[key];

    //             if (val1 !== val2) {
    //                 return false;
    //             }
    //         }
    //     }

    //     return true;
    // };

    const isEqualByKeysAndValues = (obj1: AnyObject, obj2: AnyObject): boolean => {
        if (obj1 === obj2) {
            return true;
        }

        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (const key of keys1) {
            if (!keys2.includes(key)) {
                return false;
            }

            if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
                if (obj1[key].length !== obj2[key].length) {
                    return false;
                }

                const sortedArr1 = [...obj1[key]].sort();
                const sortedArr2 = [...obj2[key]].sort();

                for (let i = 0; i < sortedArr1.length; i++) {
                    if (sortedArr1[i] !== sortedArr2[i]) {
                        return false;
                    }
                }
            } else if (key === 'leasingAgentNumber') {
                const val1 = obj1[key] ? obj1[key].toString() : obj1[key];
                const val2 = obj2[key] ? obj2[key].toString() : obj2[key];
                if (val1 !== val2) {
                    return false;
                }
            } else if (key === 'latitude' || key === 'longitude') {
                const val1 = obj1[key] ? obj1[key].toString() : obj1[key];
                const val2 = obj2[key] ? obj2[key].toString() : obj2[key];
                if (val1 !== val2) {
                    return false;
                }
                continue; // keep checking next keys
            } else {
                const val1 = obj1[key] === null ? '' : obj1[key];
                const val2 = obj2[key] === null ? '' : obj2[key];

                if (val1 !== val2) {
                    return false;
                }
            }
        }
        return true;
    };

    return (
        <div className={styles.logsModalContainer}>
            <div className={styles.modalHeader}>
                <div className={styles.inlineItems}>
                    <HistoryIcon />
                    <h2>Property Information History</h2>
                </div>
                <button className={styles.closeBtnWrapper} onClick={() => setShowPropertyInformationLogs(false)}>
                    <CloseIcon />
                </button>
            </div>

            <div className={styles.modalBody}>
                {!noRecordsFound &&
                    data &&
                    !!data.length &&
                    data.map((history: PropertyModalProps, index: number) => {
                        if (!isEqualByKeysAndValues(history.old_values, history.new_values)) {
                            return (
                                <LogsAccordion
                                    key={index}
                                    data={history}
                                    active={activeIndex === index ? true : false}
                                    onToggle={() => setActiveIndex(activeIndex === index ? null : index)}
                                />
                            );
                        }
                    })}
                {noRecordsFound && (
                    <div className={styles.noRecordsFoundWrapper}>
                        <img src={NoRecordsFound} alt="" width={132} height={160} />
                        <p className={styles.noRecordFoundText}>No Logs Found</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PropertyInformationModalBody;
